import React, { Fragment } from 'react'
import { Filter, List, useFilter, useListRepository, TextField } from 'elentari'
import configuracoesRepository from './ConfiguracoesRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import { Grid } from '@material-ui/core'
import { Field } from 'react-final-form'

const ConfiguracoesFilter = () => {
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      labels={{
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item xs={12}>
          <Field fullWidth name="chave" label="Chave" component={TextField} />
        </Grid>
      </Grid>
    </Filter>
  )
}

const Configuracoes = ({ classes, ...props }) => {
  const [ability] = useAbility()

  const metricForEachConfig = {
    MAX_SOLICITACOES_USUARIO: 'solicitações',
    TEMPO_AUTO_FINALIZAR: 'min',
    TEMPO_MAXIMO_ANALISE_SOLICITACAO: 'min',
    TEMPO_MAXIMO_FILA_SOLICITACAO: 'min',
    TEMPO_PRE_NOTIFICACAO_ANALISTA: 'min',
    TEMPO_SESSAO_USUARIO: 'min',
    EMAIL_CENTRAL_CADASTRO: ''
  }

  const listOptions = {
    fields: {
      chave: {
        label: 'Chave'
      },
      valor: {
        label: 'Valor',
        format: (value, item) => {
          const string = `${value} ${metricForEachConfig[item.chave] || ''}`
          if (string.length > 255) {
            return `${string.substring(255)}...`
          }

          return string
        }
      }
    }
  }

  const listHook = useListRepository({
    repository: configuracoesRepository,
    path: 'configuracoes'
  })
  const actions = getListActions(ability, listHook, 'configuracoes')
  const onClickEdit = item => {
    item = {
      ...item,
      id: item.chave
    }
    return actions.onClickEdit(item)
  }

  return (
    <Fragment>
      <ConfiguracoesFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickEdit={onClickEdit}
        onClickNew={null}
        onClickView={null}
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </Fragment>
  )
}

export default Configuracoes
